// Plain-English sentences the screens share ("USB-C modules at 75, below Min").
import type { ShelfRow, Violation } from "./types";

const plural = (n: number, one: string, many = one + "s") => `${n} ${n === 1 ? one : many}`;

/** "1.5 days of draw above Min" / "half a day below Min". */
export function drawPhrase(days: number | null): string | null {
  if (days == null) return null;
  const n = Math.abs(days);
  const amount = n === 0 ? "at Min" : n === 0.5 ? "half a day" : n < 1 ? "under a day" : `${Number.isInteger(n) ? n : n.toFixed(1)} ${n === 1 ? "day" : "days"}`;
  if (n === 0) return "right at Min";
  return `${amount} of draw ${days > 0 ? "above" : "below"} Min`;
}

export function shelfSentence(s: ShelfRow): string {
  if (s.countMode === "enough") {
    if (s.level.enough == null) return `${s.name}: not counted yet`;
    return `${s.name}: ${s.level.enough ? "enough" : "not enough"}`;
  }
  if (s.level.qty == null) return `${s.name}: never counted, so it can't be judged`;
  const where = s.critical != null && s.level.qty < s.critical
    ? `below Critical (${s.critical}): fill it today`
    : drawPhrase(s.daysOfDraw) ?? (s.min != null && s.level.qty < s.min ? `below Min (${s.min})` : "at or above Min");
  return `${s.name} shelf at ${s.level.qty}, ${where}`;
}

export function violationCounts(vs: Violation[]) {
  const blocks = vs.filter((v) => v.kind === "block").length;
  const warns = vs.filter((v) => v.kind === "warn").length;
  const advisories = vs.filter((v) => v.kind === "advisory").length;
  return { blocks, warns, advisories };
}

export function violationSummary(vs: Violation[]): string {
  const { blocks, warns, advisories } = violationCounts(vs);
  if (!blocks && !warns && !advisories) return "Every rule holds";
  const bits = [];
  if (blocks) bits.push(plural(blocks, "block"));
  if (warns) bits.push(plural(warns, "warning"));
  if (advisories) bits.push(plural(advisories, "advisory", "advisories"));
  return bits.join(", ");
}

export { plural };
